import React, { useState } from 'react';
import BalanceText from '@/components/BalanceText/BalanceText';
// import { Image as DatoImage } from 'react-datocms';
// import Image from 'next/legacy/image';
import Image from '@/components/ReusableUI/Image';
import { FloatUpDown } from '../Animations';
import { useRouter } from 'next/router';
import { MUZOLOGY_APP, MUZOLOGY_SIGNUP_URL } from '../../lib/defaults';
import { FixedLines, MainHeading } from '@/components/Views/Heading';
import NormalText from '@/components/Views/Text';
import LargeButton from '@/components/Views/Buttons';
import GradientBackground from '@/components/Gradient/GradientBackground';
import { ClassJoinForm } from './ClassJoinForm';
import IconBlock from '@/components/Animations/IconBlock';

interface Props {
    heading?: string;
    id?: string;
    featuredImage?: any;
}

// background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
// filter: drop-shadow(0px 0px 0.62785px rgba(38, 103, 255, 0.05)) drop-shadow(0px 10.0456px 15.0684px rgba(38, 103, 255, 0.09));
// border-radius: 20.0912px;

const Hero = ({ heading, featuredImage, id }: Props) => {
    const router = useRouter();
    heading = 'LEARNING MATH MADE EASY';
    const desktopFloatingHeartsPositions = [
        { top: '18%', left: '3%', rotate: 0, scale: 1.8, opacity: 1, className: 'w-12 md:w-16', image: '/icons/white-math-2.svg' },
        { top: '15%', right: '15%', rotate: 0, scale: 1.8, opacity: 1, className: 'w-12 md:w-16', image: '/icons/white-math-1.svg' },
        { bottom: '5%', left: '8%', rotate: 0, scale: 1.8, opacity: 1, className: 'w-12 md:w-16', image: '/icons/white-math-3.svg' }
    ];

    const mobileFloatingHeartsPositions = [
        { top: '25%', left: '15%', rotate: 0, scale: 1, opacity: 1, className: 'w-12 md:w-16', image: '/icons/white-math-1.svg' },
        { top: '25%', right: '1%', rotate: 0, scale: 1, opacity: 1, className: 'w-12 md:w-16', image: '/icons/white-math-2.svg' },
        { bottom: '8%', left: '10%', rotate: 0, scale: 1, opacity: 1, className: 'w-12 md:w-16', image: '/icons/white-math-3.svg' }
    ];

    return (
        <section
            id={id}
            className={` relative z-20 px-5 md:px-10 lg:px-15 pr-5 sm:pr-10 lg:pr-[60px] pt-12 xs:pt-10 sm:pt-0 lg:pt-[80px] bg-[#222563] pb-10`}
            // style={{ background: ' linear-gradient(90deg, #6171E5 5.98%, #222563 95.99%)' }}
        >
            <div className='relative z-10 flex flex-col lg:flex-row mx-auto items-center hero-max-w'>
                <div className='w-full'>
                    <div className='relative flex justify-center mt-0 md:mt-10 lg:mt-0'>
                        <Image image={featuredImage} priority={true} />

                        <IconBlock icons={desktopFloatingHeartsPositions} className='hidden lg:block' />
                        <IconBlock icons={mobileFloatingHeartsPositions} className='hidden sm:block lg:hidden' />
                    </div>
                </div>
                <div className='w-full mt-0 lg:pt-[75px] z-10'>
                    <div className='flex flex-col pt-0  xs:pt-0 lg:pt-[20px] gap-4'>
                        <div className='relative'>
                            <h1 className='relative text-[#fff] font-bold text-[19px] tiny:text-[23px]  sm:text-[30px] md:text-[32px]  xl:text-[41px] select-none mx-auto whitespace-pre-line font-Inter text-center my-3'>
                                <span className='whitespace-nowrap sm:block mr-2 sm:mr-0'>{heading}</span>
                            </h1>
                            {/*                                <MainHeading
                                    className='bg-green-500 relative opacity-100 mix-blend-color-burn'
                                    // heading={'Muzology makes\nlearning math fast,\nfun & easy!'}
                                    heading={<BalanceText>{`Muzology makes\nlearning math fast,\nfun & easy!`}</BalanceText>}
                                    balance={true}
                                />
                                <MainHeading
                                    className='mt-3 bg-red-400 relative opacity-100 mix-blend-color-burn'
                                    heading={<BalanceText>Muzology makes learning math fast, fun & easy!</BalanceText>}
                                    balance={true}
                                />*/}
                            {/* <div className='bg-[#333] absolute top-0 left-0 w-full h-full opacity-1' /> */}
                        </div>
                        <div className='mt-0 sm:mt-0'>
                            <NormalText as='div' className='text-center max-w-[650px] w-full mx-auto leading-6 text-[#fff]'>
                                <BalanceText className='font-bold'>
                                    Our exciting <span className='font-bold text-[#7BE7FF]'>math music videos</span> make challenging math topics easy to
                                    understand and remember.
                                </BalanceText>

                                <span className='sm:whitespace-nowrap block font-bold text-[#fff] text-xl mt-4'>
                                    Try Muzology today <span className='whitespace-nowrap text-[#7BE7FF]'>for FREE!</span>
                                </span>

                                <span className='sm:whitespace-nowrap block font-bold text-[#fff] text-sm mt-3'>
                                    Recommended for students in <span className='whitespace-nowrap'>grades 4-8.</span>
                                </span>
                            </NormalText>
                        </div>

                        <div className='mx-auto max-w-[280px] w-full'>
                            <div className='mt-3  w-full '>
                                <div className='flex justify-center'>
                                    <LargeButton
                                        onClick={() => router.push(MUZOLOGY_SIGNUP_URL)}
                                        className='purple-button w-full h-[40px] relative'
                                        id={id + '-sign-up-my-child'}
                                    >
                                        <div className='flex items-center justify-start'>
                                            <div className='text-white font-Inter font-extrabold uppercase'>Sign Up My Child</div>
                                        </div>
                                    </LargeButton>
                                </div>
                                <div className='flex justify-center mt-3'>
                                    <LargeButton
                                        onClick={() => router.push('/signup')}
                                        className='blue-button w-full h-[40px] relative'
                                        id={id + '-sign-up-as-educator'}
                                    >
                                        <div className='flex items-center justify-start'>
                                            <div className='text-white font-Inter font-extrabold uppercase'>Sign Up As Educator</div>
                                        </div>
                                    </LargeButton>
                                </div>
                            </div>
                        </div>

                        <p className='text-base text-white font-thin font-Inter text-center mt-3'>
                            Already have an account?{' '}
                            <a
                                href={`${MUZOLOGY_APP}/login/`}
                                className='text-base text-white font-Inter no-underline font-bold'
                                id={id + '-already-have-account'}
                            >
                                LOG IN
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
